module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAJCAYAAADpeqZqAAAAJklEQVQYlWP8////fwYSAQsDAwMjqZqYSNVAtiaQ80a8nxgYGBgAtGIGFlXYEfQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/common/imgs/icon/icon_allClass.png
// module id = vgDv
// module chunks = 41